import React from 'react';
import PropTypes from 'prop-types';
import DeleteModal from 'App/components/DeleteModal';

const propTypes = {
    onHide: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

const defaultProps = {};

function DetachInsuranceModal({ onHide, onConfirm }) {
    return (
        <DeleteModal
            message="Are you sure you want to detach this insurance plan?"
            show
            onHide={onHide}
            onDelete={onConfirm}
            confirmText="Detach"
            title="Detach Insurance Plan"
        />
    );
}

DetachInsuranceModal.propTypes = propTypes;
DetachInsuranceModal.defaultProps = defaultProps;

export default DetachInsuranceModal;
